import React from 'react';
import { Link } from 'react-router-dom';
import './ToolCard.css';

const ToolCard = ({ tool }) => {
  const { id, name, description, icon } = tool;

  return (
    <div className="tool-card card">
      <Link to={`/tools/${id}`} className="tool-card-link">
        <div className="tool-card-image">
          <img src={`${process.env.PUBLIC_URL}/img/${icon}`} alt={name} />
        </div>
        <div className="tool-card-content">
          <h3 className="tool-card-title">{name}</h3>
          <p className="tool-card-description">{description}</p>
        </div>
      </Link>
    </div>
  );
};

export default ToolCard; 